import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, Observer } from 'rxjs';

import { environment } from '../../../src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private http: HttpClient) {}
  header = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  getAllZones(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.DeviceApiEndPoint}/getAllZones`, '', this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }

  getWaterConsumptionWidgetDetails(body: object): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getWaterConsumption`,
          body,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }

  getDevicesStatusDetails(body: object): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getDevicesStatusDetails`,
          body,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }
  public dev_eui: string = '';

  getDataManagementWidgetData(body: object): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getDataManagementWidgetData`,
          body,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }

  getAllDevicesMapdetails(body: object): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getAllDevicesMapdetails`,
          body,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }
  addDevice(deviceData: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/addDevice`,
          {
            deviceDetails: deviceData,
          },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getdeviceType(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getAllDeviceType`,
          {},
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getUsageType(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.DeviceApiEndPoint}/getUsageType`, {}, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  setId(devEui: string) {
    this.dev_eui = devEui;
  }
  getDeviceEUI() {
    return this.dev_eui;
  }
  removeDeviceEUI() {
    this.dev_eui = '';
  }
  getDeviceDetails(devUI: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getDeviceDetails`,
          {
            devUI: devUI,
            isSearch: false,
          },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getMatchingDevices(devUI: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post<any[]>(
          `${environment.DeviceApiEndPoint}/getDeviceDetails`,
          {
            devUI: devUI,
            isSearch: true,
          },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getMatchingConsumerIDs(consumerID: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getMatchingDevices`,
          {
            consumerID: consumerID,
          },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getUsageData(data: {
    device_id: string;
    end_date: string;
    start_date: string;
  }): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getCustomDateWaterConsumption`,
          data,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getAllDevices(filterinfo: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.DeviceApiEndPoint}/getAllDevices`, {
          filterinfo,
        })
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  exportDevices(filterinfo: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportDevices`,
      { filterinfo },
      {
        responseType: 'blob',
      }
    );
  }

  getdeviceZone(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.DeviceApiEndPoint}/getDeviceZone`, {}, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getDailyAndMonthlyWaterConsumption(data: {
    device_id: string;
    timezone_offset: number;
  }): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getDailyAndMonthlyWaterConsumption`,
          data,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getOneWeekUsageData(data: { device_id: string }): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getOneWeekConsumptionAndFlowRate`,
          data
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getDeviceByConsumerID(consumerID: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getDeviceByConsumerID`,
          { consumerID },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  deleteDevice(deviceId: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/deleteDeviceByDeviceId`,
          { deviceId },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  deleteDeviceByZone(zone: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/deleteDeviceByZone`,
          { zone },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  deleteDeviceByFileUpload(consumerIDs: string[]): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/deleteDeviceByFileUpload`,
          { consumerIDs },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getFileUploadDeviceCount(consumerIDs: string[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getFileUploadDeviceCount`,
          { consumerIDs },
          this.header
        )
        .subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  downloadFile(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/downloadSampleFile`,
          {},
          {
            responseType: 'blob',
          }
        )
        .subscribe(
          (response) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getContactDetails(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .get(
          `${environment.DeviceApiEndPoint}/getContactUsDetails`,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getAllAlertedDevices(filter: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getPaginatedAlertDevices`,
          filter,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getAlertAggregation(filter: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getAlertAggregation`,
          filter,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  exportAlertedDevices(filter: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportAlertedDevices`,
      filter,
      {
        responseType: 'blob',
      }
    );
  }

  exportDeviceAlerts(filter: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportDeviceAlerts`,
      filter,
      {
        responseType: 'blob',
      }
    );
  }

  createGroup(groupName: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/createNewGroup`,
          { groupName },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  searchDeviceByNameOrId(searchKey: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/searchDeviceByNameOrId`,
          { searchKey },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  searchDeviceById(searchKey: string): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/searchDeviceById`,
          { searchKey },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  saveSettings(settings: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/saveSettings`,
          settings,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getSettings(): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(`${environment.DeviceApiEndPoint}/getSettings`, this.header)
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  getAllCmds(filterinfo: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getAllCmds`,
          { filterinfo },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  downlink(dev_eui: any, data: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/downlink`,
          { dev_eui: dev_eui, object: data },
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }
  exportCmds(filterinfo: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportCmds`,
      { filterinfo },
      {
        responseType: 'blob',
      }
    );
  }

  exportWateruses(filterinfo: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportWaterConsumption`,
      { filterinfo },
      {
        responseType: 'blob',
      }
    );
  }
  excludeDevices(filter: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/excludeDevices`,
          filter,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  getLatestCaptureDate(body: object): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getLatestCaptureDate`,
          body,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error: Error) => {
            observer.error(error);
          }
        );
    });
  }
  getWaterConsumptionChartData(filter: any): Observable<any> {
    return new Observable((observer: any) => {
      this.http
        .post(
          `${environment.DeviceApiEndPoint}/getWaterConsumptionChartData`,
          filter,
          this.header
        )
        .subscribe(
          (response: any) => {
            observer.next(response);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
    });
  }

  exportCustomDateWaterConsumption(filter: any): Observable<Blob> {
    return this.http.post(
      `${environment.DeviceApiEndPoint}/exportCustomDateWaterConsumption`,
      filter,
      {
        responseType: 'blob',
      }
    );
  }
}
